import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { acme, acmeCardSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

export function Card({ sx, children, ...props }) {
  return (
    <Paper elevation={0} sx={mergeSx(acmeCardSx, sx)} {...props}>
      {children}
    </Paper>
  );
}

export function CardHeader({ title, description, action, sx, children }) {
  return (
    <Box
      sx={mergeSx(
        {
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 2,
          px: 2.5,
          py: 2,
          borderBottom: `1px solid ${acme.colors.border}`,
        },
        sx,
      )}
    >
      <Box>
        {title && (
          <Typography sx={{ fontWeight: 600, fontSize: '1.125rem', color: acme.colors.foreground }}>
            {title}
          </Typography>
        )}
        {description && (
          <Typography sx={{ fontSize: '0.875rem', color: acme.colors.mutedForegroundSolid, mt: 0.5 }}>
            {description}
          </Typography>
        )}
        {children}
      </Box>
      {action}
    </Box>
  );
}

export function CardContent({ sx, children, ...props }) {
  return (
    <Box sx={mergeSx({ p: 2.5 }, sx)} {...props}>
      {children}
    </Box>
  );
}

export function CardFooter({ sx, children, ...props }) {
  return (
    <Box
      sx={mergeSx(
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 1,
          px: 2.5,
          py: 2,
          borderTop: `1px solid ${acme.colors.border}`,
        },
        sx,
      )}
      {...props}
    >
      {children}
    </Box>
  );
}
